import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const TaskDragIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={9}
        height={8}
        viewBox="0 0 9 8"
        className="Icon task-drag"
        {...props}
    >
        <path
            fill="#A3A7AE"
            fillRule="evenodd"
            d="M8.5 7a.5.5 0 0 1 0 1h-8a.5.5 0 0 1 0-1zm0-3.5a.5.5 0 0 1 0 1h-8a.5.5 0 0 1 0-1zm0-3.5a.5.5 0 0 1 0 1h-8a.5.5 0 0 1 0-1z"
        />
    </svg>
);
const Memo = memo(TaskDragIcon);
export default Memo;
